import React, { useContext, useEffect, useState } from 'react';
import { FaArrowCircleRight, FaEdit, FaFileAlt, FaSave } from 'react-icons/fa';
import './index.css';
import { translate } from '../../../../utils/Common';
import { useForm } from 'react-hook-form/dist/index.ie11';
import { usePlatforms } from '../../../../hooks/usePlatforms';
import Skeleton from '../../../../components/ui/Skeleton';
import { ToastContainer, useToast } from '../../../../components/common/Toast';
import BtnSync from '../../../../components/BtnSync';
import Button from '../../../../components/common/Button/Button';
import AuthContext from '../../../../contexts/auth';
import ProviderCapabilities from './ProviderCapabilities';


const FormGeneralLocker = (props) => {
  const { dataDetails, setDataDetails, setOptionSelect, setExternalId, isLoadingData, typeView, optionsProviders, permissions } = props;
  const canCreate = !!permissions?.canCreate;
  const canUpdate = !!permissions?.canUpdate;
  const canSyncDetails = !!permissions?.canSyncDetails;
  const canEditThisView = typeView === 'create' ? canCreate : canUpdate;

  const { createPlatform, getPlatformDetailsByExternalId, updateGeneralDataPlatform, updateSettingsPlatform, getSettingByPlatform } = usePlatforms();
  const userContext = useContext(AuthContext);
  const canEditExternalId = userContext?.user?.RoleBli >= 4 || userContext?.user?.roleId >= 4 || userContext?.user?.IsAdmin;
  const { register, errors, handleSubmit, setError, clearErrors, reset, watch  } = useForm();
  const { toasts, showSuccess, showError, removeToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [originalData, setOriginalData] = useState(null);
  const [editMode, setEditMode] = useState(true);

  const formFields = [
    { id: 'locationName', label: translate('dashboard.platforms.name'), required: true, colSize: 'col-span-12', valueDefault: dataDetails?.namePlatform, disabled: editMode },
    { id: 'locationId', label: translate("dashboard.platforms.support.openLockerCard.locationId"), required: true, colSize: 'col-span-12 md:col-span-6', valueDefault: dataDetails?.externalId, disabled: typeView === 'create' ? false : (editMode || !canEditExternalId) },
    // ID PUDO: siempre visible mientras exista IdPlataforma; si no existe, ocultar porque la plataforma aún no está creada
    { id: 'pudoId', label: translate("dashboard.platforms.pudoId"), required: false, colSize: 'col-span-12 md:col-span-6', valueDefault: dataDetails?.pudoId ?? '', disabled: editMode, isHidden: !dataDetails?.IdPlataforma },
    { id: 'city', label: translate("global.City"), required: true, colSize: 'col-span-12 md:col-span-6', valueDefault: dataDetails?.city, disabled: editMode },
    { id: 'address', label: translate("global.physicalAddress"), required: true, colSize: 'col-span-12', valueDefault: dataDetails?.fisicAddress, disabled: editMode },
  ];

  const selectedProviderId = watch('providerId') || dataDetails?.IdFabricante;

  const selectFields = [
    { id: 'providerId', label: translate("global.provider"), required: true, options: optionsProviders, colSize: 'col-span-12 md:col-span-8', valueDefault: dataDetails?.IdFabricante != null ? Number(dataDetails.IdFabricante) : '', disabled: editMode ? true : (typeView==='create' ? false : true) },
    { id: 'generation', label: translate("global.generation"), required: true, options: [{id: 1, value:'1'}, {id: 2, value:'2'}, {id: 3, value:'3'}, {id: 4, value:'4'}, {id: 5, value:'5'}], colSize: 'col-span-12 md:col-span-4', valueDefault: dataDetails?.IdGeneration, disabled: editMode },
    { id: 'typeLocker', label: translate("global.typeLocker"), required: true, options: [{id: 1, value:'Indoor'}, {id: 2, value:'Outdoor'}], colSize: 'col-span-12 md:col-span-8', valueDefault: dataDetails?.IdTypeLocker, disabled: editMode },
  ];

  const renderInputField = (props) => {
    const { id, label, required, colSize = "col-span-12", valueDefault = "", disabled, isHidden } = props;

    if (isHidden) {
      return null;
    }

    return (
      <div className={colSize} key={id}>
        {isLoadingData ? <div className='mt-1 mb-2'><Skeleton width={100} height={10} /></div> : <label className="text-label-title" htmlFor={id}>
            {label} {required && <span className='text-destructive'>*</span>}
          </label>}
        <div className="mb-3 mb-2">
          {isLoadingData ? <div className='mt-2 mb-3'><Skeleton width='100%' height={40} /></div> : (
            <input
            id={id}
            name={id}
            defaultValue={valueDefault}
            disabled={disabled} 
            ref={register({
              required: required && {
                value: true,
                message: translate('global.isRequerid'),
              },
            })}
            className={`h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed form-control-md${errors[id] ? ' mb-2 border-destructive' : ''}`}
          />
          )}
          
          {errors[id] && <div className="mt-1 text-xs font-medium text-destructive">{errors[id].message}</div>}
        </div> 
      </div>
    );
  };
  
  const renderSelectField = (props) => {
    const { id, label, required, options, colSize = "col-span-12", valueDefault = "", isHidden, disabled} = props;    
    
    return (
      <div className={colSize} key={id}>
      <div className="mb-3 mb-2">
        {
          !isHidden && (
            <>
{isLoadingData ? (
          <div className="mt-1 mb-2">
            <Skeleton width={100} height={10} />
          </div>
        ) : (
          <label className="text-label-title" htmlFor={id}>
            {label} {required && <span className="text-destructive">*</span>}
          </label>
        )}
        <div className="mb-3">
          {isLoadingData ? (
            <div className="mt-2 mb-3">
              <Skeleton width="100%" height={40} />
            </div>
          ) : (
            <select
              id={id}
              name={id}
              defaultValue={valueDefault}
              disabled={disabled} 
              ref={register({
                required: required && {
                  value: true,
                  message: translate('global.isRequerid'),
                },
              })}
              className={`h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed form-control-md${errors[id] ? ' mb-2 border-destructive' : ''}`}
            >
              <option value="">{translate("global.select")}...</option>
              {options.map((option, index) => (
                <option key={index} value={option.id}>
                  {option?.value}
                </option>
              ))}
            </select>
          )}
        </div>
        {errors[id] && <div className="mt-1 text-xs font-medium text-destructive">{errors[id].message}</div>}
            </>
          )
        }
        
      </div>
    </div>);
  };

  const verifyExistExternalId = async (externalId) => {
    const response = await getPlatformDetailsByExternalId(externalId);
  
    if (response) {
      setError('locationId', { type: 'manual', message: translate("global.externalIdInUse") });
      return true;
    } else {
      clearErrors('locationId');
      return false;
    }
  }

  // Muestra el error del backend en su campo cuando lo reconoce; si no, el mensaje genérico
  const showBackendError = (backendMessage) => {
    const errorMessages = {
      'MISSING_LOCATION_NAME': { field: 'locationName', message: translate('global.errors.MISSING_LOCATION_NAME') },
      'MISSING_LOCATION_ADDRESS': { field: 'address', message: translate('global.errors.MISSING_LOCATION_ADDRESS') },
      'MISSING_CITY': { field: 'city', message: translate('global.errors.MISSING_CITY') },
      'MISSING_TYPE_LOCKER': { field: 'typeLocker', message: translate('global.errors.MISSING_TYPE_LOCKER') },
      'MISSING_STATUS_ID': { field: 'statusId', message: translate('global.errors.MISSING_STATUS_ID') },
      'MISSING_ENVIRONMENT_ID': { field: 'environmentId', message: translate('global.errors.MISSING_ENVIRONMENT_ID') },
      'INVALID_PROVIDER_ID': { field: 'providerId', message: translate('global.errors.INVALID_PROVIDER_ID') },
    };

    const errorInfo = errorMessages[backendMessage];
    if (errorInfo) setError(errorInfo.field, { type: 'manual', message: errorInfo.message });
    showError(errorInfo ? errorInfo.message : translate("dashboard.packages.details.dropOff.receivePackage.NOT_FOUND"));
  }

  const submitCreatePlatform = async (data) => {
    setIsLoading(true);

    const dataToSend = {
      ...data,
      typeLocker: Number(data.typeLocker),
      pudoId: data.pudoId || null,
    }

    const abortController = new AbortController();
    const validateSubmit = await verifyExistExternalId(dataToSend.locationId); 
    if (validateSubmit) {
      setIsLoading(false);
      return;
    };
  
    const response = await createPlatform(dataToSend, abortController.signal);
    
    if (response.code === 200) {
        if (response.boxitLocationId > 0) {
           // Agregar el parámetro extId en la URL
           const url = new URL(window.location.href);
           url.searchParams.set('extId', data.locationId);
           url.searchParams.set('view', 'edit');
           window.history.pushState({}, '', url); 
           setExternalId(data.locationId);
           setOptionSelect('settings');
        }
    } else {
      showBackendError(response.message);
    }
    setIsLoading(false);
  }

  const submitUpdatePlatform = async (data) => { 
    setIsLoading(true);
    const abortController = new AbortController();
    const hasLocationIdChanged = data.locationId && data.locationId !== dataDetails?.externalId;

    // Validar permisos para editar External Id
    if (hasLocationIdChanged && !canEditExternalId) {
      setIsLoading(false);
      setError('locationId', { type: 'manual', message: translate("global.unauthorizedToEditExternalId") });
      showError(translate("global.unauthorizedToEditExternalId"));
      return;
    }

    // Si cambió External Id: enviar por PATCH /settings/{oldLocationId} con newLocationId
    if (hasLocationIdChanged) {
      const validateSubmit = await verifyExistExternalId(data.locationId);
      if (validateSubmit) {
        setIsLoading(false);
        return;
      }
      try {
        const currentSettings = await getSettingByPlatform(dataDetails.externalId, abortController.signal);
        const settingsPayload = {
          locationId: dataDetails.externalId,
          newLocationId: data.locationId,
          splashTimer: Number(currentSettings?.splashTimer) || 90000,
          supportNumber: currentSettings?.supportNumber || "718-374-6835",
          supportEmail: currentSettings?.supportEmail || "support@golocker.com",
          boxValidationTimer: Number(currentSettings?.boxValidationTimer) || 30000,
          checkItem: Boolean(currentSettings?.checkItem),
          currentTemperature: Number(currentSettings?.currentTemperature) || 28,
          tempUpperLimit: Number(currentSettings?.tempUpperLimit) || 30,
          tempLowerLimit: Number(currentSettings?.tempLowerLimit) || 27,
          fanStatus: Boolean(currentSettings?.fanStatus),
          screenId: [1, 2].includes(Number(currentSettings?.screenId)) ? Number(currentSettings.screenId) : 1,
          timeTurnLampOn: currentSettings?.timeTurnLampOn || undefined,
          timeTurnLampOff: currentSettings?.timeTurnLampOff || undefined,
        };
        const settingsResponse = await updateSettingsPlatform(settingsPayload, abortController.signal);
        if (settingsResponse.code !== 200) {
          if (settingsResponse.message === "EXTERNAL_ID_ALREADY_IN_USE" || (settingsResponse.code === 400 && settingsResponse.message === "EXTERNAL_ID_ALREADY_IN_USE")) {
            setError('locationId', { type: 'manual', message: translate("global.externalIdInUse") });
          }
          if (settingsResponse.message === "UNAUTHORIZED_TO_EDIT_EXTERNAL_ID" || (settingsResponse.code === 403 && settingsResponse.message === "UNAUTHORIZED_TO_EDIT_EXTERNAL_ID")) {
            setError('locationId', { type: 'manual', message: translate("global.unauthorizedToEditExternalId") });
          }
          const errorMessage = settingsResponse.message === "EXTERNAL_ID_ALREADY_IN_USE"
            ? translate("global.externalIdInUse")
            : settingsResponse.message === "UNAUTHORIZED_TO_EDIT_EXTERNAL_ID"
              ? translate("global.unauthorizedToEditExternalId")
              : translate("dashboard.packages.details.dropOff.receivePackage.NOT_FOUND");
          showError(errorMessage);
          setIsLoading(false);
          return;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('extId', data.locationId);
        window.history.pushState({}, '', url);
        setExternalId(data.locationId);
      } catch (err) {
        showError(translate("dashboard.packages.details.dropOff.receivePackage.NOT_FOUND"));
        setIsLoading(false);
        return;
      }
    }

    const dataToSend = {
      ...data,
      locationName: data.locationName,
      address: data.address || '',
      city: data.city || '',
      generation: Number(data.generation),
      statusId: dataDetails.IdEstatus,
      environmentId: dataDetails.IdTipoAmbiente,
      locationId: hasLocationIdChanged ? data.locationId : dataDetails.externalId,
      typeLocker: Number(data.typeLocker) || Number(dataDetails.IdTypeLocker) || 0,
      providerId: Number(dataDetails.IdFabricante),
      pudoId: data.pudoId || null,
    };
  
    const response = await updateGeneralDataPlatform(dataToSend, abortController.signal);
   
    if (response.code === 200) {
      showSuccess(translate("global.updateSuccessGeneralDataPlatform"));
      setEditMode(true);
      setOriginalData(data); 

      // Actualiza los DATOS CON LOS DATOS ANTERIORES
      const newExternalId = hasLocationIdChanged ? data.locationId : dataDetails.externalId;
      setDataDetails((prevData) => ({
        ...prevData,
        externalId: newExternalId,
        pudoId: data.pudoId ?? prevData.pudoId,
        fisicAddress: data.address,
        city: data.city,
        namePlatform: data.locationName,
        IdGeneration: Number(data.generation),
        IdFabricante: Number(dataDetails.IdFabricante),
        IdTypeLocker: Number(data.typeLocker) || prevData.IdTypeLocker,
      }));
      reset({ ...data, locationId: newExternalId, locationName: data.locationName, city: data.city, address: data.address, pudoId: data.pudoId });

    } else {
      showBackendError(response.message);
      reset(originalData); // Restablece los valores originales en el formulario
    }
    setIsLoading(false);
  }

  useEffect(() => {
    if (typeView === 'edit' && dataDetails) {
      setEditMode(true);
      setOriginalData(dataDetails); // Guarda los datos originales
      reset(dataDetails); // Establece los valores iniciales en el formulario
      return;
    }
    if (typeView === 'create') {
      setEditMode(false);
      return;
    }

  }, [typeView]);

  return (
    <form className='cardInternal' onSubmit={handleSubmit(typeView === 'create' ? submitCreatePlatform : submitUpdatePlatform)}>
      <div className="cardInternal-header">
        <div className='cardInternal-title'>
          <span className="mr-1"><FaFileAlt /></span>
          {translate("global.generalData")}
        </div>
        <div className="cardInternal-actions" style={{display:"flex",alignItems:"center", gap:'15px'}}>
          {canSyncDetails && dataDetails?.IdPlataforma && <BtnSync mode="general" platformId={dataDetails?.IdPlataforma}/> }
          {
            !isLoadingData && (
            dataDetails ? (
              <div className="flex items-center" style={{gap:'10px'}}>
              {
                editMode ? (
              canUpdate && (
                <Button variant="ghostOutline" size="sm" leftIcon={<FaEdit />} type='button' onClick={() => setEditMode((prevMode) => !prevMode)}>
                  {translate("global.edit")} 
                </Button>
              )
                ):(
                  <>
                    <Button variant="ghostOutline" size="sm" type='button' onClick={() => {
                      reset(originalData);
                      setEditMode((prevMode) => !prevMode);
                      }} >
                     {translate("global.cancel")} 
                  </Button>
                  <Button variant="primary" size="sm" leftIcon={<FaSave />} type='submit' loading={isLoading} disabled={!canEditThisView}>
                   {translate("global.save")} 
                  </Button>
                  </>
                )
              }
              
              {editMode && <Button variant="ghostOutline" size="sm" rightIcon={<FaArrowCircleRight />} onClick={() => setOptionSelect('settings')}>
               {translate("login.signup.btn.next")}
              </Button>
              }
              </div>
              
            ) : (
            <Button variant="primary" size="sm" leftIcon={<FaSave />} disabled={isLoading || !canEditThisView} loading={isLoading} type="submit">
              {translate("global.save")}
            </Button>
            ) )
          }
        </div>
      </div>
      <div className="cardInternal-body">
        <div className="grid grid-cols-12 gap-x-4">
          {formFields.map((field) => renderInputField(field))}
          {selectFields.map((field) => renderSelectField(field))}
          {!isLoadingData && <ProviderCapabilities providerId={selectedProviderId} providers={optionsProviders} />}
        </div>
      </div>
      {/* Toast Notifications */}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </form>
  );
};

export default FormGeneralLocker;